import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';

interface SignUpWrapperProps {
  children: React.ReactNode;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
}

const SignUpWrapper: React.FC<SignUpWrapperProps> = ({
  children,
  formHeaderTitle,
  formHeaderDescription,
}) => {
  const { sliderIndex } = useContext(TranslatingContainerContext)!;

  return (
    <Container>
      <FormSectionHeader>
        <FormSectionHeaderTitle>{formHeaderTitle}</FormSectionHeaderTitle>
        <FormSectionHeaderDescription>
          {formHeaderDescription}
        </FormSectionHeaderDescription>
      </FormSectionHeader>
      <ProgressBar>
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className={index <= sliderIndex ? 'highlight' : ''}
          ></div>
        ))}
      </ProgressBar>
      {children}
    </Container>
  );
};

export default SignUpWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;
  width: 400px;
  margin: 0 auto;

  @media (max-width: 884px) {
    width: 100%;
    max-width: 400px;
  }
`;

const FormSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FormSectionHeaderTitle = styled.div`
  display: flex;
  text-align: left;
  font-size: 20px;
  line-height: 27.32px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const FormSectionHeaderDescription = styled.div`
  display: flex;
  text-align: left;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.formDescriptionText};
`;

const ProgressBar = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: -4px;
  margin-bottom: 12px;
  gap: 4px;

  & > div {
    background-color: ${({ theme }) => theme.palette.borderColor};
    height: 2px;
    border-radius: 1px;

    &.highlight {
      background-color: ${({ theme }) => theme.palette.blueColor};
    }
  }
`;
